// extracted by mini-css-extract-plugin
module.exports = {"radioButton":"RadioButton_radioButton__1sPFz","label":"RadioButton_label__2dN5s","primaryText":"RadioButton_primaryText__2ApTT","secondaryText":"RadioButton_secondaryText__g2ml9"};